module.exports = __webpack_public_path__ + "img/icon-flexibility.c1d20421.png";